module.exports = new __parcel__URL__("industrial3.19cca205.jpg").toString();